import React, {FC, useEffect, useLayoutEffect, useRef, useState} from "react";
import {filter as filterrx}                 from "rxjs/operators";
import {docKeyDown$}                        from "@sirius/ui-lib/src/subjects/DocKeyDown";
import {Button, TextInput}                  from "@sirius/ui-lib/src/blocks/Controls";
import {HBox, SGap}                         from "@sirius/ui-lib/src/blocks/Layout";
import {SortFilterPopupType}                from "./@types";
import {block}                              from "./block";



export const SortFilterPopup: FC<SortFilterPopupType> = ({
    offset,
    sortAsc,
    sortDesc,
    filterChange,
    sort,
    filter
}) => {
    const [inputFilter, setInputFilter] = useState<string>(filter);

    const inputRef = useRef<HTMLInputElement>(null);
    const KeyboardFilterEnter = filterrx( ({target, code}: KeyboardEvent) =>
        (code === 'Enter' && inputRef?.current === target)
    );
    useEffect(() => {
        const subKD = docKeyDown$.pipe( KeyboardFilterEnter )
            .subscribe(() => filterChange(inputFilter) )
        ;
        return () => subKD.unsubscribe()
    });

    useLayoutEffect(()=>{
        if (inputRef.current) {
            inputRef.current.select()
        }
    }, ['']);

    const onChangeInput = (value: string) => {
        setInputFilter(value);
    };

    const stopEvent = (e: React.MouseEvent)=> {
        e.stopPropagation()
    };

    const hasInput = filter !== void(0);

    return  <HBox
                className = {block.el('sort-filter-popup-wrapper')}
                onClick   = {stopEvent}
            >
                <HBox
                    className = {block.el('sort-filter-popup')}
                    style     = {{left: offset}}
                >
                    {
                        hasInput &&
                        <>
                            <TextInput
                                inputRef     = {inputRef}
                                onChange     = {onChangeInput}
                                placeholder  = {'Найти'}
                                defaultValue = {filter}
                                autofocus    = {true}
                            />
                            <SGap/>
                        </>
                    }
                    {
                        sort !== void(0) &&
                        <>
                            <Button
                                size     = "s"
                                mode     = "text"
                                icon     = "north"
                                active   = {sort === "asc"}
                                onAction = {sortAsc}
                            />
                            <SGap/>
                            <Button
                                size     = "s"
                                mode     = "text"
                                icon     = "south"
                                active   = {sort === "desc"}
                                onAction = {sortDesc}
                            />
                        </>
                    }
                </HBox>
            </HBox>
    ;
};
